/**
 * D-131: a till bill only partly taxed, split into its taxed part and an exempt part — in words.
 *
 * A split's suggested value is an object, not a string, so the suggestion list groups it by its
 * rule rather than by its printed value: every bill with no GST is one decision, and every bill
 * taxed on part of it another. Each bill is still worked out by the service from its own row.
 */

export const SPLIT_FIELD = '_split'

export interface Split {
  taxed: number
  exempt: number
  rate: number
  note?: string
}

function rupees(paise: number): string {
  return (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** What a split did to a bill, for the bill's own row. */
export function splitWords(split: Split): string {
  if (!split.taxed) return 'No GST on this bill: reported whole as exempt (Table 8).'
  return (
    `Split: ₹${rupees(split.taxed)} taxed at ${split.rate}%, ₹${rupees(split.exempt)} with no ` +
    'GST, reported as exempt (Table 8).'
  )
}

/** The key a suggestion is grouped under — a split by its rule, anything else as before. */
export function suggestionGroupKey(s: {
  field: string
  value: unknown
  rule_id: string
  reason: string
}): string {
  if (s.field === SPLIT_FIELD) return `${s.field}:${s.rule_id}`
  return `${s.field}:${String(s.value)}:${s.rule_id}:${s.reason}`
}

/** A group of split suggestions in words: one bill's own reason, or what the group holds. */
export function splitGroupWords(ruleId: string, n: number, reason: string): string {
  if (n === 1) return reason
  return ruleId === 'split.untaxed_bill'
    ? `${n} bills with no GST — each reported as exempt (Table 8) and asked of the client`
    : `${n} bills taxed on only part of their value — each split at its own tax, the untaxed ` +
        'part exempt (Table 8) and asked of the client'
}
